import { useContext } from 'react'
import { ConferenceContext } from 'contexts/conference'
import { useNavigate } from 'react-router-dom'
import { ANALYTICS_EVENTS } from 'constants/analyticsEvents'
import {
    logZoomClassEnded,
    logZoomStudentLeft,
    type ZoomClassEndTrigger
} from 'services/zoomLifecycleFaroLogger'

interface LeaveHandlerParams {
    (isTeacher: boolean, path: string, trigger?: ZoomClassEndTrigger): void
}

const useLeaveLesson = (): { onLeaveHandler: LeaveHandlerParams } => {
    const conference = useContext(ConferenceContext)
    const navigate = useNavigate()

    const onLeaveHandler: LeaveHandlerParams = (isTeacher, path, trigger) => {
        if (conference.status === 'session-joined') {
            if (isTeacher) {
                logZoomClassEnded(trigger ?? ANALYTICS_EVENTS.END_CLASS_BUTTON)
                void conference.rtcSession.end()
                conference.primus.send('end-session', {})
            } else {
                logZoomStudentLeft()
                void conference.rtcSession.leave()
            }
        }
        navigate(path)
    }

    return { onLeaveHandler }
}

export { useLeaveLesson }
